import { render, staticRenderFns } from "./sys-setting.vue?vue&type=template&id=1f3a3adc&scoped=true"
import script from "./sys-setting.vue?vue&type=script&lang=js"
export * from "./sys-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3a3adc",
  null
  
)

export default component.exports